import React, { useState } from "react";
import { Typography } from "@mui/material";
import rightStyles from "./UpdateRight.module.css";
import UpdateRightModal from "./UpdateRightModal";
import {useFetchAllRights} from "../../../../hooks/authorization/useFetchAllRights";
import {RightWithPositionsAndUsers, UpdateRight} from "../../../../types/api/authorization/right.types";
import useAppSnackbar from "../../../../hooks/useAppSnackbar";
import {rightService} from "../../../../services/authorization/right-service";

export const UpdateRightView = () => {
    const {showSuccess, showError, SnackbarComponent} = useAppSnackbar();
    const [selectedRight, setSelectedRight] = useState<RightWithPositionsAndUsers | null>(null);
    const [searchQuery, setSearchQuery] = useState<string>("");

    const {
        data: dataRight,
        refetch: rightRefetch
    } = useFetchAllRights();

    const handleRightClick = (right: RightWithPositionsAndUsers) => {
        setSelectedRight(right);
    };

    const handleCloseModal = () => {
        setSelectedRight(null);
    };

    const handleSaveRight = async (rightData: UpdateRight) => {
        console.log("Updating right:", rightData);
        try {
            await rightService.update(rightData);
            showSuccess("Права успешно обновлены");
            rightRefetch();
        }
        catch (e) {
            showError("Обновление прав прошло неуспешно");
        }

        handleCloseModal();
    };

    const filteredRights = (dataRight ?? []).filter(r => {
        const q = searchQuery.trim().toLowerCase();
        if (!q) return true;
        const title = (r.title ?? "").toLowerCase();
        const tag = (r.tag ?? "").toLowerCase();
        const comment = (r.comment ?? "").toLowerCase();
        return title.includes(q) || tag.includes(q) || comment.includes(q);
    });

    return (
        <div className={rightStyles.page}>
            <div className={rightStyles.pageContainer}>
                <div className={rightStyles.headerRow}>
                    <div>
                        <h1 className={rightStyles.pageTitle}>Права</h1>
                        <p className={rightStyles.pageSubtitle}>Управление правами доступа</p>
                    </div>
                    <div className={rightStyles.headerActions}>
                        <div className={rightStyles.searchInput}>
                            <span className={rightStyles.searchIcon}>🔍</span>
                            <input
                                className={rightStyles.searchField}
                                placeholder="Поиск прав..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className={rightStyles.cardsGrid}>
                    {filteredRights.map((right) => (
                        <div
                            key={right.id}
                            className={`${rightStyles.card} ${
                                selectedRight?.id === right.id ? rightStyles.cardSelected : ""
                            }`}
                            onClick={() => handleRightClick(right)}
                        >
                            <div className={rightStyles.cardHeader}>
                                <Typography className={rightStyles.cardTitle}>
                                    {right.title}
                                </Typography>
                                {right.tag && <span className={rightStyles.badge}>{right.tag}</span>}
                            </div>
                            {right.comment && <p className={rightStyles.cardDesc}>{right.comment}</p>}
                            <p className={rightStyles.cardHint}>Нажмите для редактирования</p>
                        </div>
                    ))}
                </div>
            </div>

            {selectedRight && (
                <UpdateRightModal
                    right={selectedRight}
                    onClose={handleCloseModal}
                    onSave={handleSaveRight}
                />
            )}
            <SnackbarComponent/>
        </div>
    );
};

export default UpdateRightView;
